var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{class:{'no-label-switch' : _vm.noLabel},attrs:{"color":_vm.color,"hide-details":"","label":_vm.label,"loading":_vm.loading,"disabled":_vm.loading || _vm.disabled,"readonly":_vm.readonly},on:{"change":_vm.toggle},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }